import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable()
export class CrewEventManager {
    private authenticationSuccessObservable: Observable<Nema.Crew.Model.ApplicationUser>;
    private authenticationSuccessObserver: Observer<Nema.Crew.Model.ApplicationUser>;

    private logoutSuccessObservable: Observable<any>;
    private logoutSuccessObserver: Observer<any>;

    constructor() {
        this.authenticationSuccessObservable = CrewEventManager.createObservable(observer => this.authenticationSuccessObserver = observer);
        this.logoutSuccessObservable = CrewEventManager.createObservable(observer => this.logoutSuccessObserver = observer);
    }

    onAuthenticationSuccess(callback: (userIdentity: Nema.Crew.Model.ApplicationUser) => void): void {
        this.authenticationSuccessObservable.subscribe(callback);
    }

    authenticationSuccess(userIdentity: Nema.Crew.Model.ApplicationUser): void {
        CrewEventManager.broadcast(this.authenticationSuccessObserver, userIdentity);
    }

    onLogoutSuccess(callback: () => void): void {
        this.logoutSuccessObservable.subscribe(callback);
    }

    logoutSuccess(): void {
        CrewEventManager.broadcast(this.logoutSuccessObserver, {});
    }

    private static createObservable<T>(setObserver: (observer: Observer<T>) => void): Observable<T> {
        return new Observable((observer: Observer<T>) => setObserver(observer)).pipe(share());
    }

    private static broadcast<T>(observer: Observer<T>, event: T) {
        if (observer != null) {
            observer.next(event);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/event-manager.service.ts